import { apiClient } from '@/api/core/apiClient';
import { API_CONFIG } from '@/api/core/apiConfig';
import { buildQueryString } from '@/api/shared/queryBuilder';
import type { ApiResponse } from '@/api/shared/types';
import { mapLocationEmployeeItem } from '../checkInLocation.mapper';
import type { LC_GetLocationEmployeesOut, LC_GetLocationEmployeesParams, LocationEmployeeItem } from '../checkInLocation.types';


export interface LocationEmployeesAvailableResult {
  items: LocationEmployeeItem[];
  totalRecords: number;
}

export class LocationEmployeesAvailableService {
  async getAvailable(
    locationId: number,
    params?: LC_GetLocationEmployeesParams,
    signal?: AbortSignal,
  ): Promise<ApiResponse<LocationEmployeesAvailableResult>> {
    const queryString = buildQueryString(params ?? {});
    const endpoint = `${API_CONFIG.ENDPOINTS.CHECK_IN_LOCATION.EMPLOYEES_AVAILABLE(locationId)}${queryString}`;

    const response = await apiClient.get<LC_GetLocationEmployeesOut>(endpoint, { signal });

    if (response.success && response.data) {
      return {
        ...response,
        data: {
          items: (response.data.data ?? []).map(mapLocationEmployeeItem),
          totalRecords: response.data.pagination?.totalRecords ?? 0,
        },
      };
    }

    return { ...response, data: null };
  }
}

export const locationEmployeesAvailableService = new LocationEmployeesAvailableService();
